<template>
    <section class="payView">
		<van-nav-bar title="充值" class="top_bar" v-if="status == 2 || status == 3" />	
		<van-nav-bar title="充值" left-arrow @click-left="skipFull" class="top_bar" v-else />
        <div v-html="html" v-if="status == 1"></div>
        <section class="recharge_success" v-else-if="status == 2">
            <img src="../../../assets/img/recharge_success.png" />
            <p>充值成功</p>
            <van-button round type="danger" class="danger-button" @click="skipOrder">立即抢单</van-button>
        </section>
        <section class="recharge_fail" v-else-if="status == 3">
            <img src="../../../assets/img/recharge_fail.png" />
            <p>充值失败</p>
            <van-button round type="danger" class="danger-button" @click="skipKefu">联系客服</van-button>
        </section>
        <section class="recharge_loading" v-else-if="status == 4">
            <img src="../../../assets/img/recharge_loading.png" />
            <p>正在查询充值结果，请稍后…</p>
        </section>
		<van-loading size="24px" vertical v-if="payParams.cashierTypeId == 2 && isLoading">加载中...</van-loading>

    </section>
</template>
<script>
import buyServer from "api/buy";
import Nav from "components/Nav"
import { Notify } from 'vant';

export default {
    name: "payView",
	components: {
		Nav,
		Notify,
	},
    data() {
        return {
            html: ``,
            status: 1,
			payId: '',
            payParams: {
                orderId: "",
                cashierTypeId: "",
                amount: "",
                description: "充值",
                remark: "",
                returnUrl: "",
            },
			iap: '',
			restoreFlag: true,
			iapIds: [],
			productid: '',
			sid: '',
			serialNum: '',
			isLoading: false,
        };
    },
	// 支付宝1
	// 微信
	// 内购 2
    created() {
		this.status = localStorage.getItem("status")
        this.payParams.orderId = this.$route.params.id;
        this.payParams.amount = this.$route.params.amount;
        this.payParams.cashierTypeId = this.$route.params.type;
        this.productid = this.$route.params.pid||0;
        this.sid = this.$route.params.sid;
		this.payParams.returnUrl = `https://sdzyios.jiexinhome.com/#/payview/${this.payParams.orderId}/${this.payParams.amount}/${this.payParams.cashierTypeId}/${this.productid}/${this.sid}`;
		if(this.status==1) {
			if(this.payParams.cashierTypeId == 1) {
				this.showPageView()
			}else if(this.payParams.cashierTypeId == 2) {
				this.isLoading = true 
				kk_inAppPurchases({id:this.productid},(res)=>{
					this.isLoading = false
					if(res.code == 1) {
						this.status = 2
					}else {
						this.status = 3
						return
					}
				});
			}
		}else {
			this.payId= localStorage.getItem("pay")
			//获取支付状态
			this.training = setInterval(this.getPayStatus, 400)
		}
	},
	

	beforeDestroy() {
		clearInterval(this.training)
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
    methods: {
		appInit() {
			var bridge = window.KKJSBridge
			var plugins = bridge.KKIvars.plugins
			bridge.addFunction("aliPayResult", (res)=> {})
		},
        showPageView() {
            buyServer.SearchPayView(this.payParams).then((res) => {
				if(this.payParams.cashierTypeId == 2) {
					this.html = ''
					localStorage.setItem("pay", res.data.id)
					this.serialNum = res.data.cashierSerialNum
					this.getOrderInfo()
				}else {
					this.html = res.data.payParams.split('</form>')[0]
					localStorage.setItem("status", 4)
					localStorage.setItem("pay", res.data.id)
					this.$nextTick(() => {
						document.forms[0].submit();
					});
					setTimeout(() => {
						this.status = 4
					}, 1000)
				}
            });
        },
		getPayStatus() {
			buyServer.SearchPayInfo({id: this.payId}).then((res) => {
				if (!res.data) return
				if(res.data.status == 20) {
					this.status = 2
					localStorage.setItem("status", 2)
				}else if(res.data.status == 10) {
					this.status = 4
					localStorage.setItem("status", 4)
				}else {
					this.status = 3
					localStorage.setItem("status", 3)
				}
				if(res.data.status != 10) {
					clearInterval(this.training)
				}
			})
		},

		skipOrder() {
			this.$router.push({name: 'index'})
		},
		skipKefu() {
			this.$router.push({name: 'kefu'})
		},
		skipFull() {
			this.$router.push({name: 'full'})
		},

		//------------------------- ios内购支付 -------------------------
		getProductId() {
			this.iapIds = []
			buyServer.SearchPayList().then((res) => {
				res.data.forEach((item) => {
					this.iapIds.push(item.appleGoodsId)
				})
			})
		},
		getIosIap() {
			if(!window.plus) return
			plus.payment.getChannels((channels)=> {  
				for (var i in channels) {  
					var channel = channels[i];  
					// 获取 id 为 'appleiap' 的 channel  
					if (channel.id === 'appleiap') {  
						this.iap = channel;  
					}  
				}  
			}, (e)=> {  
				console.log("获取iap支付通道失败：" + e.message);  
			});
		},
		getOrderInfo() {
			// iapIds 为在苹果开发者后台配置的应用内购项目的标识集合  
			// iap 为刚刚获取的`appleiap`支付通道  
			this.iap.requestOrder(this.iapIds, (e)=> {  
				// 获取订单信息成功回调方法  
				console.log('requestOrder success: ' + JSON.stringify(e));  
				this.payFn()
			}, (e)=> {  
				// 获取订单信息失败回调方法  
				console.log('requestOrder failed: ' + JSON.stringify(e));  
			});
		},
		payFn() {
			// restoreFlag 标记，用于判断在页面显示的时候是否需要调用 restoreComplateRequest 方法  
			this.restoreFlag = true; // 调用支付接口时标记 restoreFlag = true , 实际应用请将标记存储在 storage 中  
			plus.payment.request(this.iap, {  
				productid: this.productid,  
				username: localStorage.getItem("token")||"appusername", // 用户标识  
				optimize: true  // 设置 optimize: true 解决丢单问题  
			}, (result)=> { 
				this.isLoading = false 
				this.status = 4
				let params = {
					transactionID: result.transactionIdentifier,//苹果支付订单
					payload: result.transactionReceipt,//base64校验
					serialNum: this.serialNum,//订单id
					type: 1, //0沙盒 1正式
				}
				// 支付成功，result 为 IAP商品交易信息对象 IAPTransaction 需将返回的支付凭证传给后端进行二次认证  
				this.verificationPay(params)

			}, (e)=> {  
				// 支付失败的时候需要调用一下 restoreComplateRequest 方法  
				this.restoreComplateRequest()  
			});
		},
		restoreComplateRequest() {  
			this.iap.restoreComplateRequest({}, function(results) {  
				// results 格式为数组存放恢复的IAP商品交易信息对象 IAPTransaction，需要将返回的支付凭证传给后端进行二次认证  
			});  
		},
		verificationPay(row) {
			buyServer.verificatPay(row).then((res) => {
				this.restoreFlag = false; // 支付成功清除标记 restoreFlag = false 
				console.log('开始轮训');
				this.payId= localStorage.getItem("pay")
				this.training = setInterval(this.getPayStatus, 400)
			})
		}
    },
};
</script>

<style lang="scss">
.payView {
    .recharge_success,
    .recharge_fail {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 100%;
        img {
            width: 104px;
        }
        p {
            color: #2b2f3a;
            font-size: 20px;
            font-weight: bold;
            padding-top: 15px;
        }
        .van-button--danger {
            margin-top: 68px;
            width: 217px;
            height: 46px;
            font-size: 17px;
            font-weight: bold;
            .van-button__text {
                color: #fff;
                padding-top: 0;
            }
        }
    }
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.block {
		width: 120px;
		height: 120px;
		background-color: #fff;
	}
	.van-loading {
		position: fixed;
		top: 30%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
    .recharge_loading {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 100%;
        img {
            width: 120px;
        }
        p {
            color: #575e72;
            font-size: 16px;
            padding-top: 36px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/user/payview/PayView.vue